import script from "./BalanceReminder.vue?vue&type=script&setup=true&lang=ts&MinusCircleOutlined=true&name=BalanceReminder"
export * from "./BalanceReminder.vue?vue&type=script&setup=true&lang=ts&MinusCircleOutlined=true&name=BalanceReminder"

import "./BalanceReminder.vue?vue&type=style&index=0&id=71d9ecb4&lang=scss&scope=true"

const __exports__ = script;

export default __exports__